import React from 'react'
import {
    Home as HomeIcon,
    Group as GroupIcon,
    Pages as PageIcons,
    MonetizationOn as SubscribeIcon,
    Feedback as FeedbackIcon,
    GroupAdd as ReferralCodeIcon
} from '@material-ui/icons'

const structure = [
    { id: 0, label: 'Dashboard', link: process.env.PUBLIC_URL + '/app/dashboard', icon: <HomeIcon /> },
    {
        id: 1,
        label: 'Users',
        link: process.env.PUBLIC_URL + '/app/users',
        icon: <GroupIcon />
    },

    {
        id: 2,
        label: 'Subscription',
        link: process.env.PUBLIC_URL + '/app/subscription',
        icon: <SubscribeIcon />
    },

    {
        id: 3,
        label: 'Feedback',
        link: process.env.PUBLIC_URL + '/app/feedback',
        icon: <FeedbackIcon />
    },

    {
        id: 4,
        label: 'Pages',
        link: process.env.PUBLIC_URL + '/app/pages',
        icon: <PageIcons />,
        children: [
            {
                label: 'Help',
                link: process.env.PUBLIC_URL + '/app/pages/addEdithelp',
            },
            // {
            //     label: 'Contact Us',
            //     link: process.env.PUBLIC_URL + '/app/pages/contactUs',
            // },
            {
                label: 'Privacy Policy',
                link: process.env.PUBLIC_URL + '/app/pages/addEditprivacy',
            },
            {
                label: 'Terms & Condition',
                link: process.env.PUBLIC_URL + '/app/pages/editterms',
            }
        ],
    },

    {
        id: 3,
        label: 'Currency Converter',
        link: process.env.PUBLIC_URL + '/app/currencyconverter',
        icon: <SubscribeIcon />
    },

    {
        id: 3,
        label: 'Referral Code',
        link: process.env.PUBLIC_URL + '/app/referralcodes',
        icon: <ReferralCodeIcon />
    },
]

export default structure
